module.exports = __webpack_public_path__ + "img/ugx.f9bd816.7590d1c2.svg";